// Theme is the only piece of UI state persisted outside IndexedDB: a single
// localStorage key, applied as a data attribute the theme layer keys off. The
// key is exported so a full data reset can clear it too.
export const THEME_STORAGE_KEY = "trustlens.theme";
const KEY = THEME_STORAGE_KEY;
export type Theme = "light" | "dark";

export function currentTheme(): Theme {
  const stored = localStorage.getItem(KEY);
  if (stored === "light" || stored === "dark") return stored;
  return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem(KEY, theme);
}

export function toggleTheme(): Theme {
  const next: Theme = currentTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}
